import React from "react";
import styles from "./EquipmentsGrid.module.scss";
import Localizer from "@/localization/Localizer";
import {PageRoute} from "@renta-apps/athenaeum-react-common";
import {Link} from "@renta-apps/athenaeum-react-components";
import {Text} from "@renta-apps/renta-react-components";
import {ProductWithTelematicsDetails} from "@/models/server/Models/Equipment/ProductWithTelematicsDetails";
import PageDefinitions from "@/providers/PageDefinitions";

interface TitleAreaProps {
    equipmentDetails: ProductWithTelematicsDetails;
    label: string;
    mode: "device" | "rental" | "contract";
    expanded?: boolean;
    returnRequestId?: string;
    onAccordionTitleAreaButtonClick?: () => void,
}

const TitleArea: React.FC<TitleAreaProps> = ({equipmentDetails, label, mode, expanded, returnRequestId, onAccordionTitleAreaButtonClick}) => {

    let route: PageRoute | null = null;
    if (mode === "device") {
        route = equipmentDetails.url && equipmentDetails.isMassProduct
        ? PageDefinitions.productDetails.route({ id: equipmentDetails.url! })
        : PageDefinitions.deviceDetailsPage.route({ params: { rentaId: equipmentDetails.rentaId! } });
    } else if (mode === "rental" && returnRequestId) {
        route = PageDefinitions.adminReturnDetails.route({id: returnRequestId});
    }

    return (
        <div className={styles.titleArea}>
            <div className={styles.deviceExpandedInfoTitle}>
                <Text tag={"label"} size={"Large"} weight="bold" className={styles.title}>
                    {label}
                </Text>
                {((equipmentDetails.isRented && mode == "device") || (mode === "rental" && returnRequestId)) && (
                    <span data-cy="more-info">
                        <Link
                            className={styles.link}
                            route={route}
                        >
                            {Localizer.equipmentGridMoreInfo}
                        </Link>
                    </span>
                )}
                {mode === "contract" && onAccordionTitleAreaButtonClick !== undefined && (
                    <div className={styles.titleExpand}>
                        <div className={styles.accordionButton} onClick={onAccordionTitleAreaButtonClick} data-cy={`accordion-button-${label.replace(/\s+/g, "")}`}>
                            <i className={`fas fa-angle-down ${expanded ? styles.rotated : ""}`}></i>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TitleArea;